import React from 'react';
import cx from 'classnames';
import '../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../../common/GradientWrapper/index.js';
import '../../../../common/Icon/index.js';
import '../../../../common/LazyImage/index.js';
import '../../../../common/NumberFormat/index.js';
import { WithCustomScrollbar } from '../../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const FormGroup = ({
  children,
  noMobileScroll
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, { [styles["no-mobile-scroll"]]: noMobileScroll })
  },
  /* @__PURE__ */ React.createElement(WithCustomScrollbar, { className: styles.scroll }, /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, children))
);
FormGroup.displayName = "Auth.Form.FormGroup";

export { FormGroup };
//# sourceMappingURL=index.js.map
